function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPptx = function SvgPptx(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "\\u56FE\\u5C42 1",
    viewBox: "0 0 1024 1024"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "PPTX_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h1024v1024H0z",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#PPTX_svg__a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M807.34 323.61 655.02 180.39a151.995 151.995 0 0 0-104.14-41.3H258.49c-41.2 0-74.6 33.4-74.6 74.59v596.78c0 41.2 33.4 74.6 74.6 74.6h522.15c41.2 0 74.6-33.4 74.59-74.6V434.38c0-41.95-17.33-82.03-47.89-110.77M580.58 167.84l244.14 229.48H655.18c-41.2.02-74.6-33.38-74.6-74.59zM418.76 768.09V448.22h140.22c32.26 0 56.67 8.29 73.25 24.86 16.58 16.58 24.87 39.8 24.87 69.66 0 29.87-8.29 53.16-24.87 69.89-16.58 16.73-40.99 24.94-73.25 24.64h-97.66v130.82h-42.56Zm42.56-284.03v117.38h83.33c24.19.3 41.89-4.63 53.09-14.78 11.2-10.15 16.8-24.79 16.8-43.9s-5.6-33.67-16.8-43.68c-11.2-10.01-28.9-15.01-53.09-15.01h-83.33Z",
    style: {
      fillRule: "evenodd"
    }
  })));
};
export default SvgPptx;